import axios from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../constants/api';
import { TIPOS_EXAMEN, methods } from '../constants/constants';
import { actions as preguntasActions } from '../reducers/preguntas';
import { sagaNames, handleSagaError } from './index';
import { getPreguntaById } from '../utils/dataHandlers/PreguntasDataHandler';
import { normalizeExamen, normalizeMateriasErroneas, normalizePreguntasExamenesAcademia, normalizeRecuentoMaterias } from './normalizers/preguntasNormalizer';

export const preguntasFromStore = state => state.preguntas.preguntas;
export const preguntasExamenesAcademiaFromStore = state => state.preguntas.preguntasExamenesAcademia;
export const preguntasExamenesAcademiaCrudFromStore = state => state.preguntas.preguntasExamenesAcademiaCrud;

function fetchPreguntas() {
	return axios({
    method: methods.GET,
    url: API.PREGUNTAS.GET_PREGUNTAS,
	});
}

function postPreguntasData(pregunta) {
  const { id, idExamen, enunciado, numeroPregunta, correcta, idMateria, feedback } = pregunta;
	return axios({
		method: methods.POST,
		url: API.PREGUNTAS.GET_PREGUNTAS,
    data: {
      id,
      idExamen,
      enunciado,
      numeroPregunta,
      correcta,
      idMateria,
      feedback
    },
	});
}

function putPreguntasData(pregunta) {
  const { id, idExamen, enunciado, numeroPregunta, correcta, idMateria, feedback } = pregunta;
	return axios({
    method: methods.PUT,
    url: API.PREGUNTAS.GET_PREGUNTAS,
    data: {
      idPregunta: id,
      idExamen,
      enunciado,
      numeroPregunta,
      correcta,
      idMateria,
      feedback
    },
	});
}

function deletePreguntasData(pregunta) {
  const { id, idExamen, enunciado, numeroPregunta, correcta, idMateria } = pregunta;
	return axios({
		method: methods.DELETE,
    url: `${API.PREGUNTAS.GET_PREGUNTAS}?idPregunta=${id}`,
    // data: {
    //   idPregunta: id,
    //   idExamen,
    //   enunciado,
    //   numeroPregunta,
    //   correcta,
    //   idMateria
    // },
	});
}

function fetchPregunta(idPregunta) {
	return axios({
    method: methods.GET,
    url: `${API.PREGUNTAS.GET_PREGUNTA}?idPregunta=${idPregunta}`,
	});
}

function fetchPreguntasExamenesAcademia() {
	return axios({
    method: methods.GET,
    url: API.PREGUNTAS.GET_PREGUNTAS_EXAMENES_ACADEMIA,
	});
}

function fetchPreguntasExamenesAcademiaCrud() {
	return axios({
    method: methods.GET,
    url: API.PREGUNTAS.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD,
	});
}

function postExportBuscadorPreguntasPdfData(exportRequest) {
	return axios({
  method: methods.POST,
  url: API.PREGUNTAS.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF,
  data: exportRequest,
	});
}

function postPreguntaConOpcionesData(pregunta, type) {
  const {
    idExamen,
    id,
    idPregunta,
    nombreExamen,
    enunciado,
    numeroPregunta,
    nombreMateria,
    idMateria,
    correcta,
    opcion,
    numeroRespuestas,
    respuestas,
    feedback
  } = pregunta;

  let url = API.PREGUNTAS.ADD_PREGUNTA_CON_OPCIONES;
  let method = methods.POST;

  if (type === 'edit') {
    url = API.PREGUNTAS.EDIT_PREGUNTA_CON_OPCIONES;
    method = methods.PUT;
  }

	return axios({
		method,
		url,
    data: {
      idExamen,
      pregunta: {
        id: id || idPregunta,
        nombreExamen,
        enunciado,
        numeroPregunta: parseInt(numeroPregunta, 10),
        nombreMateria,
        idMateria,
        correcta,
        opcion,
        numeroRespuestas,
        respuestas,
        feedback
      }
    },
	});
}

function fetchRecuentoMaterias(idsExamen) {
  const idsExamenToApi = idsExamen || '0';
	return axios({
    method: methods.GET,
    url: `${API.PREGUNTAS.GET_RECUENTO_MATERIAS}?idsExamen=${idsExamenToApi}`,
	});
}

function fetchCasosClinicosExamen(idExamen) {
	return axios({
    method: methods.GET,
    url: API.CASOS_CLINICOS.GET_BY_EXAMEN(idExamen),
	});
}

function postCasoClinicoData(casoClinico) {
	return axios({
    method: methods.POST,
    url: API.CASOS_CLINICOS.CASOS_CLINICOS,
    data: casoClinico,
	});
}

function putCasoClinicoData(idCasoClinico, casoClinico) {
	return axios({
    method: methods.PUT,
    url: API.CASOS_CLINICOS.CASO_CLINICO(idCasoClinico),
    data: casoClinico,
	});
}

function saveCasosClinicosExamenData(idExamen, casosClinicosRequest) {
	return axios({
    method: methods.POST,
    url: API.CASOS_CLINICOS.SAVE_BY_EXAMEN(idExamen),
    data: casosClinicosRequest,
	});
}

function deleteCasoClinicoData(idCasoClinico) {
	return axios({
    method: methods.DELETE,
    url: API.CASOS_CLINICOS.CASO_CLINICO(idCasoClinico),
	});
}

function uploadCasosClinicosExcelData(formData) {
	return axios({
    method: methods.POST,
    url: API.CASOS_CLINICOS.UPLOAD_EXCEL,
    data: formData,
	});
}

function* handleCasosClinicosSagaError(currentSagaName, error, reducerFailureAction) {
  if (error?.response?.status === 401 || error?.response?.status === 498) {
    yield handleSagaError(currentSagaName, error, reducerFailureAction);
    return;
  }

  yield put(reducerFailureAction);
}

function postPreguntasExamenData(preguntasExamen, isErroneas) {
  const urlApi = isErroneas ? API.PREGUNTAS.POST_PREGUNTAS_EXAMEN_ERRONEAS : API.PREGUNTAS.POST_PREGUNTAS_EXAMEN
	return axios({
    method: methods.POST,
    url: urlApi,
    data: preguntasExamen
	});
}

function fetchPreguntasExamenReal(idExamen) {
	return axios({
    method: methods.GET,
    url: `${API.PREGUNTAS.GET_PREGUNTAS_EXAMEN_REAL}?idExamen=${idExamen}`,
	});
}

function postPreguntasFinalizarExamenData(preguntasExamen, isErroneas, modoExamen) {
	return axios({
    method: methods.POST,
    url: API.PREGUNTAS.POST_PREGUNTAS_FINALIZAR_EXAMEN,
    data: {
      listaPreguntas: preguntasExamen,
      isErroneas,
      modoExamen,
    }
	});
}

function fetchMateriasErroneas() {
	return axios({
    method: methods.GET,
    url: `${API.PREGUNTAS.GET_MATERIAS_ERRONEAS}`,
	});
}

function deleteAllPreguntasErroneasData() {
	return axios({
		method: methods.DELETE,
    url: API.PREGUNTAS.DELETE_ALL_PREGUNTAS_ERRONEAS,
	});
}

function createBlobFromBase64(base64Content, contentType = 'application/pdf') {
  const binaryContent = window.atob(base64Content || '');
  const byteArrays = [];

  for (let offset = 0; offset < binaryContent.length; offset += 1024) {
    const slice = binaryContent.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);

    for (let index = 0; index < slice.length; index++) {
      byteNumbers[index] = slice.charCodeAt(index);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}

function downloadGeneratedPdfFiles(files = []) {
  files.forEach((file) => {
    if (!file?.contentBase64 || !file?.fileName) {
      return;
    }

    const blob = createBlobFromBase64(file.contentBase64, file.contentType || 'application/pdf');
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = blobUrl;
    link.download = file.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  });
}

export function* getPreguntas() {
  try {
    const preguntasStore = yield select(preguntasFromStore);
    let preguntas = null;
    if (!preguntasStore || (Array.isArray(preguntasStore) && preguntasStore.length === 0)) {
      const response = yield call(fetchPreguntas);
      preguntas = response && response.data;
    } else {
      preguntas = preguntasStore;
    }
      yield put(preguntasActions.successGetPreguntas(preguntas));

  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetPreguntas(error);
    yield handleSagaError(sagaNames.GET_PREGUNTAS, error, reducerFailureAction);
  }
}

export function* postPreguntas(args) {
    try {
        //debugger;
    const response = yield call(postPreguntasData, args.pregunta);
    // const status = response && response.status;
    yield put(preguntasActions.successPostPreguntas(response));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorPostPreguntas(error);
    yield handleSagaError(sagaNames.POST_PREGUNTAS, error, reducerFailureAction);
  }
}

export function* editPreguntas(args) {
  try {
    const response = yield call(putPreguntasData, args.pregunta);
    // const status = response && response.status;
    yield put(preguntasActions.successEditPreguntas(response));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorEditPreguntas(error);
    yield handleSagaError(sagaNames.EDIT_PREGUNTAS, error, reducerFailureAction);
  }
}

export function* deletePreguntas(args) {
    try {
        //debugger;
    const response = yield call(deletePreguntasData, args.pregunta);
    // const status = response && response.status;
        yield put(preguntasActions.successDeletePreguntas(response));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorDeletePreguntas(error);
    yield handleSagaError(sagaNames.DELETE_PREGUNTAS, error, reducerFailureAction);
  }
}

export function* getPregunta(args) {
  try {
    const preguntasStore = yield select(preguntasFromStore);
    let pregunta = null;
    if (preguntasStore && Array.isArray(preguntasStore) && preguntasStore.length > 0) {
      pregunta = getPreguntaById(preguntasStore, args.idPregunta);
    }
    if (!pregunta) {
      const response = yield call(fetchPregunta, args.idPregunta);
      pregunta = response && response.data;
    }
      yield put(preguntasActions.successGetPregunta(pregunta));

  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetPregunta(error);
    yield handleSagaError(sagaNames.GET_PREGUNTAS, error, reducerFailureAction);
  }
}

export function* getPreguntasExamenesAcademia() {
  try {
    const preguntasExamenesAcademiaStore = yield select(preguntasExamenesAcademiaFromStore);
    let preguntasExamenesAcademia = null;
    if (!preguntasExamenesAcademiaStore || (Array.isArray(preguntasExamenesAcademiaStore) && preguntasExamenesAcademiaStore.length === 0)) {
      const response = yield call(fetchPreguntasExamenesAcademia);
      preguntasExamenesAcademia = response && response.data && response.data.examenes;
    } else {
      preguntasExamenesAcademia = preguntasExamenesAcademiaStore;
    }
    const preguntasExamenesAcademiaNormalizer = normalizePreguntasExamenesAcademia(preguntasExamenesAcademia)
    yield put(preguntasActions.successGetPreguntasExamenesAcademia(preguntasExamenesAcademiaNormalizer));

  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetPreguntasExamenesAcademia(error);
    yield handleSagaError(sagaNames.GET_PREGUNTAS_EXAMENES_ACADEMIA, error, reducerFailureAction);
  }
}

export function* getPreguntasExamenesAcademiaCrud() {
  try {
    const preguntasExamenesAcademiaCrudStore = yield select(preguntasExamenesAcademiaCrudFromStore);
    let preguntasExamenesAcademiaCrud = null;
    if (!preguntasExamenesAcademiaCrudStore || (Array.isArray(preguntasExamenesAcademiaCrudStore) && preguntasExamenesAcademiaCrudStore.length === 0)) {
      const response = yield call(fetchPreguntasExamenesAcademiaCrud);
      preguntasExamenesAcademiaCrud = response && response.data && response.data.examenes;
    } else {
      preguntasExamenesAcademiaCrud = preguntasExamenesAcademiaCrudStore;
    }
    const preguntasExamenesAcademiaCrudNormalizer = normalizePreguntasExamenesAcademia(preguntasExamenesAcademiaCrud)
    yield put(preguntasActions.successGetPreguntasExamenesAcademiaCrud(preguntasExamenesAcademiaCrudNormalizer));

  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetPreguntasExamenesAcademiaCrud(error);
    yield handleSagaError(sagaNames.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD, error, reducerFailureAction);
  }
}

export function* postExportBuscadorPreguntasPdf(args) {
  try {
    const response = yield call(postExportBuscadorPreguntasPdfData, args.exportRequest);
    const files = response?.data?.files || [];

    if (!Array.isArray(files) || files.length === 0) {
      throw new Error('No se han recibido archivos PDF para descargar.');
    }

    yield call(downloadGeneratedPdfFiles, files);
    yield put(preguntasActions.successPostExportBuscadorPreguntasPdf({
      total: files.length,
      fileNames: files.map(file => file.fileName),
    }));
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 498) {
      const reducerFailureAction = preguntasActions.errorPostExportBuscadorPreguntasPdf(error);
      yield handleSagaError(sagaNames.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF, error, reducerFailureAction);
      return;
    }

    yield put(preguntasActions.errorPostExportBuscadorPreguntasPdf(error));
  }
}

export function* postPreguntaConOpciones(args) {
  try {
      //debugger;
  const response = yield call(postPreguntaConOpcionesData, args.pregunta, 'add');
  // const status = response && response.status;
  yield put(preguntasActions.successPostPreguntaConOpciones(response));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorPostPreguntaConOpciones(error);
    yield handleSagaError(sagaNames.POST_PREGUNTA_CON_OPCIONES, error, reducerFailureAction);
  }
}

export function* editPreguntaConOpciones(args) {
  try {
      //debugger;
  const response = yield call(postPreguntaConOpcionesData, args.pregunta, 'edit');
  // const status = response && response.status;
  yield put(preguntasActions.successEditPreguntaConOpciones(response));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorEditPreguntaConOpciones(error);
    yield handleSagaError(sagaNames.EDIT_PREGUNTA_CON_OPCIONES, error, reducerFailureAction);
  }
}

export function* getRecuentoMaterias(args) {
  const { idsExamen } = args;
  try {
      const response = yield call(fetchRecuentoMaterias, idsExamen);
      const recuentoMaterias = response && response.data;
      const recuentoMateriasNormalizer = normalizeRecuentoMaterias(recuentoMaterias)
      yield put(preguntasActions.successGetRecuentoMaterias(recuentoMateriasNormalizer));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetRecuentoMaterias(error);
    yield handleSagaError(sagaNames.GET_RECUENTO_MATERIAS, error, reducerFailureAction);
  }
}

export function* getCasosClinicosExamen(args) {
  const { idExamen } = args;
  try {
      const response = yield call(fetchCasosClinicosExamen, idExamen);
      yield put(preguntasActions.successGetCasosClinicosExamen(response && response.data, idExamen));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetCasosClinicosExamen(error);
    yield handleCasosClinicosSagaError(sagaNames.GET_CASOS_CLINICOS_EXAMEN, error, reducerFailureAction);
  }
}

function* refreshCasosClinicosExamen(idExamen) {
  const response = yield call(fetchCasosClinicosExamen, idExamen);
  yield put(preguntasActions.successCasosClinicosMutation(response && response.data));
}

export function* postCasoClinico(args) {
  const { casoClinico } = args;
  try {
    const response = yield call(postCasoClinicoData, casoClinico);
    const idExamen = response?.data?.idExamen || casoClinico?.idExamen;
    yield call(refreshCasosClinicosExamen, idExamen);
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorCasosClinicosMutation(error);
    yield handleCasosClinicosSagaError(sagaNames.POST_CASO_CLINICO, error, reducerFailureAction);
  }
}

export function* putCasoClinico(args) {
  const { idCasoClinico, casoClinico } = args;
  try {
    const response = yield call(putCasoClinicoData, idCasoClinico, casoClinico);
    const idExamen = response?.data?.idExamen || casoClinico?.idExamen;
    yield call(refreshCasosClinicosExamen, idExamen);
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorCasosClinicosMutation(error);
    yield handleCasosClinicosSagaError(sagaNames.PUT_CASO_CLINICO, error, reducerFailureAction);
  }
}

export function* deleteCasoClinico(args) {
  const { idCasoClinico, idExamen } = args;
  try {
    yield call(deleteCasoClinicoData, idCasoClinico);
    yield call(refreshCasosClinicosExamen, idExamen);
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorCasosClinicosMutation(error);
    yield handleCasosClinicosSagaError(sagaNames.DELETE_CASO_CLINICO, error, reducerFailureAction);
  }
}

export function* saveCasosClinicosExamen(args) {
  const { idExamen, casosClinicosRequest } = args;
  try {
    const response = yield call(saveCasosClinicosExamenData, idExamen, casosClinicosRequest);
    yield put(preguntasActions.successCasosClinicosMutation(response && response.data));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorCasosClinicosMutation(error);
    yield handleCasosClinicosSagaError(sagaNames.SAVE_CASOS_CLINICOS_EXAMEN, error, reducerFailureAction);
  }
}

export function* uploadCasosClinicosExcel(args) {
  const { formData, idExamen } = args;
  try {
    const response = yield call(uploadCasosClinicosExcelData, formData);
    const responseData = response && response.data;
    yield put(preguntasActions.successCasosClinicosMutation(
      Array.isArray(responseData)
        ? { idExamen, casosClinicos: responseData }
        : responseData
    ));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorCasosClinicosMutation(error);
    yield handleCasosClinicosSagaError(sagaNames.UPLOAD_CASOS_CLINICOS_EXCEL, error, reducerFailureAction);
  }
}

export function* postPreguntasExamen(args) {
  const { preguntasExamen, tipo, isErroneas = false } = args;
  try {
    let response = null;
    let examen = null;
    if (tipo === TIPOS_EXAMEN.REAL) {
      response = yield call(fetchPreguntasExamenReal, preguntasExamen);
      examen = response && response.data && response.data.preguntas;
    } else {
      response = yield call(postPreguntasExamenData, preguntasExamen, isErroneas);
      examen = response && response.data;
    }
    const examenNormalizer = normalizeExamen(examen, tipo, isErroneas);
    yield put(preguntasActions.successPostPreguntasExamen(examenNormalizer));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorPostPreguntasExamen(error);
    yield handleSagaError(sagaNames.POST_PREGUNTAS_EXAMEN, error, reducerFailureAction);
  }
}

export function* postPreguntasFinalizarExamen(args) {
  const { preguntasExamen, isErroneas, modoExamen } = args;
  try {
    let response = null;
    let examen = null;
    response = yield call(postPreguntasFinalizarExamenData, preguntasExamen, isErroneas, modoExamen);
    examen = response && response.data;
    // const examenNormalizer = normalizeExamen(examen, tipo);
    yield put(preguntasActions.successPostPreguntasFinalizarExamen(examen));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorPostPreguntasFinalizarExamen(error);
    yield handleSagaError(sagaNames.POST_PREGUNTAS_FINALIZAR_EXAMEN, error, reducerFailureAction);
  }
}

export function* getMateriasErroneas() {
  try {
      const response = yield call(fetchMateriasErroneas);
      const materiasErroneas = response && response.data;
      const materiasErroneasNormalizer = normalizeMateriasErroneas(materiasErroneas)
      yield put(preguntasActions.successGetMateriasErroneas(materiasErroneasNormalizer));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorGetMateriasErroneas(error);
    yield handleSagaError(sagaNames.GET_MATERIAS_ERRONEAS, error, reducerFailureAction);
  }
}

export function* deleteAllPreguntasErroneas() {
  try {
    const response = yield call(deleteAllPreguntasErroneasData);
    yield put(preguntasActions.successDeleteAllPreguntasErroneas(response));
  } catch (error) {
    const reducerFailureAction = preguntasActions.errorDeleteAllPreguntasErroneas(error);
    yield handleSagaError(sagaNames.DELETE_ALL_PREGUNTAS_ERRONEAS, error, reducerFailureAction);
  }
}
